export enum APIType {
  'fym' = 'fym',
  'music' = 'music',
}
